import { useMemo } from "react";

import { TicketProgressStageMessages } from "../constants";
import { TicketProgressStage } from "../types";

interface Props {
  status: TicketProgressStage;
  assignedDate?: string;
}

const TicketProgressBar = (props: Props) => {
  const { status, assignedDate } = props;
  const currentStatusMessage = TicketProgressStageMessages[status];

  const getColor = useMemo(() => {
    const statusOrder = Object.keys(TicketProgressStageMessages).indexOf(
      status,
    );
    return (stage: TicketProgressStage) => {
      const stageOrder = Object.keys(TicketProgressStageMessages).indexOf(
        stage,
      );
      return stageOrder <= statusOrder ? "#CE8E1F" : "#DDDDE2";
    };
  }, [status]);

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex h-1.5 w-full space-x-1.5">
        <div
          className="flex-1 rounded-l-full"
          title={TicketProgressStageMessages.raised}
          style={{ backgroundColor: getColor("raised") }}
        />
        <div
          className="flex-1"
          title={TicketProgressStageMessages.assigned}
          style={{ backgroundColor: getColor("assigned") }}
        />
        <div
          className="flex-1 rounded-r-full"
          title={TicketProgressStageMessages.resolved}
          style={{ backgroundColor: getColor("resolved") }}
        />
      </div>
      <div className="flex h-full w-full flex-row justify-between text-xs">
        <p className="font-semibold">{currentStatusMessage}</p>
        {assignedDate && <p className="text-grey-1100">{assignedDate}</p>}
      </div>
    </div>
  );
};

export default TicketProgressBar;
